const statsBuffer = {
  value: null,
  addProjectionMetrics: null
};
export {
  statsBuffer
};
